import { PaymentProps } from "../PaymentProps";
import { PaymentLayout } from "../PaymentLayout";
import { PaymentEntities } from "../PaymentEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";


export interface SubscriptionListPageProps extends NSARouterMakerResult, PaymentProps
{ }

function SubscriptionListPage(props: SubscriptionListPageProps) 
{
    return (
        <PaymentLayout {...props}
            action={{
                title: '',
                description: 'A list of all your subscriptions, along with their details and current statuses.',
                menus: {}
            }}
            pages={{
                entity: PaymentEntities.Subscription(props),
                list: {
                    ui: {}
                }
            }}
        >
            <></>
        </PaymentLayout >
    );
}

export default SubscriptionListPage;